import { render, staticRenderFns } from "./VxSpoiler.vue?vue&type=template&id=6f9a6449&scoped=true"
import script from "./VxSpoiler.vue?vue&type=script&lang=js"
export * from "./VxSpoiler.vue?vue&type=script&lang=js"
import style0 from "./VxSpoiler.vue?vue&type=style&index=0&id=6f9a6449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a6449",
  null
  
)

export default component.exports